/**
 * academicCalendar2026.js
 * 수원대학교 2026학년도 공식 학사일정 데이터
 *
 * 출처: 수원대학교 2026학년도 학사일정 (menuno=727)
 * 마지막 확인: 2026-06-27
 *
 * category 코드:
 *   course_registration  — 수강신청 기간
 *   tuition_registration — 등록기간
 *   semester_start       — 개강
 *   exam                 — 학기말고사
 *   makeup_period        — 보강기간
 *   vacation             — 방학 시작(예정)
 *   seasonal_semester    — 계절학기
 *   leave_return         — 휴학/복학 신청
 *   graduation           — 학위수여식
 *   admission            — 입학식
 *   anniversary          — 개교기념일
 *   class_day_marker     — 수업일수 1/2·3/4
 */

export const ACADEMIC_CALENDAR_2026 = [
  {
    id: 'cal2026-winter-seasonal-prev',
    title: '동계 계절학기',
    startDate: '2025-12-22',
    endDate: '2026-01-09',
    academicYear: 2026,
    term: '동계',
    category: 'seasonal_semester',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
  {
    id: 'cal2026-s1-leave-return',
    title: '휴학/복학 신청 (1학기)',
    startDate: '2026-02-02',
    endDate: '2026-02-05',
    academicYear: 2026,
    term: '1학기',
    category: 'leave_return',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
  {
    id: 'cal2026-graduation-prev',
    title: '2025학년도 학위수여식',
    startDate: '2026-02-12',
    endDate: '2026-02-12',
    academicYear: 2026,
    term: '공통',
    category: 'graduation',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
  {
    id: 'cal2026-s1-tuition',
    title: '재학생 제1학기 등록기간',
    startDate: '2026-02-23',
    endDate: '2026-02-25',
    academicYear: 2026,
    term: '1학기',
    category: 'tuition_registration',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
  {
    id: 'cal2026-s1-course-reg',
    title: '재학생 제1학기 수강신청기간',
    startDate: '2026-02-24',
    endDate: '2026-02-27',
    academicYear: 2026,
    term: '1학기',
    category: 'course_registration',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
  {
    id: 'cal2026-admission',
    title: '2026학년도 입학식',
    startDate: '2026-03-03',
    endDate: '2026-03-03',
    academicYear: 2026,
    term: '공통',
    category: 'admission',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
  {
    id: 'cal2026-s1-start',
    title: '제1학기 개강',
    startDate: '2026-03-04',
    endDate: '2026-03-04',
    academicYear: 2026,
    term: '1학기',
    category: 'semester_start',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
  {
    id: 'cal2026-s1-half',
    title: '수업일수 1/2 (1학기)',
    startDate: '2026-04-22',
    endDate: '2026-04-28',
    academicYear: 2026,
    term: '1학기',
    category: 'class_day_marker',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
  {
    id: 'cal2026-s1-three-quarter',
    title: '수업일수 3/4 (1학기)',
    startDate: '2026-05-22',
    endDate: '2026-05-22',
    academicYear: 2026,
    term: '1학기',
    category: 'class_day_marker',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
  {
    id: 'cal2026-s1-exam',
    title: '1학기 학기말고사',
    startDate: '2026-06-10',
    endDate: '2026-06-16',
    academicYear: 2026,
    term: '1학기',
    category: 'exam',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
  {
    id: 'cal2026-s1-makeup',
    title: '1학기 보강기간',
    startDate: '2026-06-17',
    endDate: '2026-06-23',
    academicYear: 2026,
    term: '1학기',
    category: 'makeup_period',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
  {
    id: 'cal2026-summer-vacation',
    title: '하계방학 시작 (예정)',
    startDate: '2026-06-24',
    endDate: '2026-06-24',
    academicYear: 2026,
    term: '하계',
    category: 'vacation',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
  {
    id: 'cal2026-summer-seasonal',
    title: '하계 계절학기 (예정)',
    startDate: '2026-06-29',
    endDate: '2026-07-17',
    academicYear: 2026,
    term: '하계',
    category: 'seasonal_semester',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
  {
    id: 'cal2026-s2-leave-return',
    title: '휴학/복학 신청 (2학기)',
    startDate: '2026-08-03',
    endDate: '2026-08-06',
    academicYear: 2026,
    term: '2학기',
    category: 'leave_return',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
  {
    id: 'cal2026-graduation-late',
    title: '2025학년도 후기 학위수여일',
    startDate: '2026-08-19',
    endDate: '2026-08-19',
    academicYear: 2026,
    term: '공통',
    category: 'graduation',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
  {
    id: 'cal2026-s2-tuition',
    title: '재학생 제2학기 등록기간',
    startDate: '2026-08-24',
    endDate: '2026-08-28',
    academicYear: 2026,
    term: '2학기',
    category: 'tuition_registration',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
  {
    id: 'cal2026-s2-course-reg',
    title: '재학생 제2학기 수강신청기간',
    startDate: '2026-08-25',
    endDate: '2026-08-28',
    academicYear: 2026,
    term: '2학기',
    category: 'course_registration',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
  {
    id: 'cal2026-s2-start',
    title: '제2학기 개강',
    startDate: '2026-09-01',
    endDate: '2026-09-01',
    academicYear: 2026,
    term: '2학기',
    category: 'semester_start',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
  {
    id: 'cal2026-anniversary',
    title: '개교기념일',
    startDate: '2026-09-25',
    endDate: '2026-09-25',
    academicYear: 2026,
    term: '공통',
    category: 'anniversary',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
  {
    id: 'cal2026-s2-half',
    title: '수업일수 1/2 (2학기)',
    startDate: '2026-10-20',
    endDate: '2026-10-26',
    academicYear: 2026,
    term: '2학기',
    category: 'class_day_marker',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
  {
    id: 'cal2026-s2-three-quarter',
    title: '수업일수 3/4 (2학기)',
    startDate: '2026-11-19',
    endDate: '2026-11-19',
    academicYear: 2026,
    term: '2학기',
    category: 'class_day_marker',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
  {
    id: 'cal2026-s2-exam',
    title: '2학기 학기말고사',
    startDate: '2026-12-08',
    endDate: '2026-12-14',
    academicYear: 2026,
    term: '2학기',
    category: 'exam',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
  {
    id: 'cal2026-s2-makeup',
    title: '2학기 보강기간',
    startDate: '2026-12-15',
    endDate: '2026-12-22',
    academicYear: 2026,
    term: '2학기',
    category: 'makeup_period',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
  {
    id: 'cal2026-winter-vacation',
    title: '동계방학 시작 (예정)',
    startDate: '2026-12-23',
    endDate: '2026-12-23',
    academicYear: 2026,
    term: '동계',
    category: 'vacation',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
  {
    id: 'cal2026-winter-seasonal',
    title: '동계 계절학기 (예정)',
    startDate: '2026-12-28',
    endDate: '2027-01-15',
    academicYear: 2026,
    term: '동계',
    category: 'seasonal_semester',
    sourceType: 'official',
    sourceName: '수원대학교 2026학년도 학사일정',
    sourceUrl: 'https://www.suwon.ac.kr/index.html?menuno=727',
    lastCheckedAt: '2026-06-27',
    status: 'verified',
    confidence: 'high',
  },
]
